module.exports = function(app) {
	'use strict';
	app.service('coverageBuddy', ['$state', '$filter', 'modal', 'services','sessionData',
		function($state, $filter, modal, services,sessionData) {

			this.isLobActive = function(lob) {
				return Boolean(
					!lob.coverageEndDate ||
					new Date(new Date(lob.coverageEndDate).setHours(0, 0, 0, 0)) > new Date((new Date()).setHours(0, 0, 0, 0))
				);
			};

			this.getCoveragesByGroupNumber = function(participant, groupNumber) {
				var memberCoverages = participant.memberCoverages || [];
				return memberCoverages.filter(
					function(g) { return g.groupNumber == groupNumber; }
				);
			};

			this.getCoverageByGroupNumber = function(participant, groupNumber) {
				var memberCoverages = participant.memberCoverages || [];
				return memberCoverages.filter(
					function(g) { return g.groupNumber == groupNumber; }
				)[0];
			};

			this.getLobByProductId = function(coverage, productId) {
				return (coverage.memberLobs || []).filter(function(lob) {
					return lob.productId === productId;
				})[0];
			};

			this.getLobByLineOfBusiness = function(coverage, lineOfBusiness) {
				return (coverage.memberLobs || []).filter(function(lob) {
					return lob.lineOfBusiness === lineOfBusiness;
				})[0];
			};

			this.removeLobFromGroup = function(coverage, lineOfBusiness) {
				for (var i = 0; i < (coverage.memberLobs || []).length; ++i) {
					if (coverage.memberLobs[i].lineOfBusiness === lineOfBusiness) {
						(function(bullseye) {
							coverage.memberLobs.splice(bullseye, 1);
						}(i));
						break;
					}
				}
			};

			this.isGroupActive = function(participant, groupNumber) {
				var group = this.getCoveragesByGroupNumber(participant, groupNumber)[0];
				return group && (group.memberLobs || []).some(this.isLobActive);
			}.bind(this);
            this.isGroupFutureActive = function(participant, groupNumber) {
                var group = this.getCoveragesByGroupNumber(participant, groupNumber)[0];
                return group && (group.memberLobs || []).some(this.isLobFutureActive);
            }.bind(this);

            this.isLobFutureActive = function(lob) {
                return Boolean(
                    !lob.coverageEndDate &&
                    new Date(new Date(lob.coverageEffectiveDate).setHours(0, 0, 0, 0)) > new Date((new Date()).setHours(0, 0, 0, 0))
                );

            };

			this.isGroupCancelled = function(participant, groupNumber) {
				return !this.isGroupActive(participant, groupNumber);
			}.bind(this);

			this.getAllGroupNumbers = function(participant) {
				var memberCoverages = participant.memberCoverages || [];
				return memberCoverages.map(function(c) { return c.groupNumber; });
			};

			this.getActiveGroupNumbers = function(participant) {
				var memberCoverages = participant.memberCoverages || [];
				return memberCoverages.filter(
					function(c) {
						return this.isGroupActive(participant, c.groupNumber);
					}.bind(this)
				).map(
					function(g) { return g.groupNumber; }
				);
			}.bind(this);
            this.getFutureActiveGroupNumbers = function(participant) {
                var memberCoverages = participant.memberCoverages || [];
                return memberCoverages.filter(
                    function(c) {
                        return this.isGroupFutureActive(participant, c.groupNumber);
                    }.bind(this)
                ).map(
                    function(g) { return g.groupNumber; }
                );
            }.bind(this);

			this.getCancelledGroupNumbers = function(participant) {
				var memberCoverages = participant.memberCoverages || [];
				return memberCoverages.filter(
					function(c) {
						return this.isGroupCancelled(participant, c.groupNumber);
					}.bind(this)
				).map(function(g) { return g.groupNumber; });
			}.bind(this);

			this.getGroupsWithCoverageType = function(participant, coverageType) {
				coverageType = coverageType.toLowerCase();
				return (participant && participant.memberCoverages || []).filter(function(g) {
					return (
						g &&
						Array.isArray(g.memberLobs) &&
						g.memberLobs.some(
							function(lob) { return lob.coverageType && lob.coverageType.toLowerCase() === coverageType; }
						)
					);
				});
			};

			this.hasActiveGroups = function(participant) {
				return participant.memberCoverages.some(
					function(c) {
						return this.isGroupActive(participant, c.groupNumber);
					}.bind(this)
				);
			};

			this.groupIsMajorMedical = function(g) {
				return g.memberLobs.some(function(lob) { // according to current knowledge, if a group contains
					return Boolean(                      // any of the following, we know it is Major Medical
						lob.lineOfBusiness.toUpperCase() === 'MM' ||
						lob.lineOfBusiness.toUpperCase() === 'FA' ||
						lob.lineOfBusiness.toUpperCase() === 'PR'
					);
				});
			};

			this.getParticipantsWithMedical = function(employeeData, employeeMetadata) {
				var planCoverageOptIn = employeeMetadata.planCoverageOptIn || { subscriber: {}, dependents: [] };

				var withMedical = [];
				if (planCoverageOptIn.subscriber.medical) { withMedical.push(employeeData.subscriber); }
				for (var i = 0; i < planCoverageOptIn.dependents.length; ++i) {
					if (planCoverageOptIn.dependents[i].medical) {
						withMedical.push(employeeData.dependents[i]);
					}
				}
				return withMedical;
			}.bind(this);

			this.getParticipantsWithProviders = function(employeeData, groupNumber) {
				var withProviders = [];

				[employeeData.subscriber].concat(employeeData.dependents).forEach(function(participant) {
					if (participant.memberCoverages && Array.isArray(participant.memberCoverages)) {
						for (var i = 0; i < participant.memberCoverages.length; ++i) {
							if (groupNumber && participant.memberCoverages[i].groupNumber !== groupNumber) {
								continue;
							}
							if (participant.memberCoverages[i].providerInformation) {
								withProviders.push(participant);
							}
						}
					}
				});
				return withProviders;
			};

			this.hasParticipantsWithProviders = function(employeeData, groupNumber) {
				return Boolean(this.getParticipantsWithProviders(employeeData, groupNumber).length);
			}.bind(this);

			this.hasReportCodes = function(employeeData) {
				var subscriber = employeeData.subscriber;
				if (subscriber.memberCoverages && subscriber.memberCoverages.length > 0) {
					var i = subscriber.memberCoverages.length;
					while (i--) {
						if (subscriber.memberCoverages[i].reportCodes && subscriber.memberCoverages[i].reportCodes.length > 0) {
							return true;
						}
					}
				}
				return false;
			};

			this.getReportCodeGroups = function(employeeData) {
				var reportCodeGroups = [];
				var subscriber = employeeData.subscriber;
				if (subscriber.memberCoverages && subscriber.memberCoverages.length > 0) {
					var i = subscriber.memberCoverages.length;
					while (i--) {
						if (
							subscriber.memberCoverages[i].reportCodes &&
							subscriber.memberCoverages[i].reportCodes.length > 0 &&
							subscriber.memberCoverages[i].memberLobs.length > 0
						) {
							reportCodeGroups.push(subscriber.memberCoverages[i].groupNumber);
						}
					}
				}
				return reportCodeGroups;
			};

			this.getCoverageCategoryCode = function(subscriber, spouse, domesticPartner, depCount) {
				if (!subscriber) {
					return;
				}
				if (!spouse && !domesticPartner && depCount < 1) {
					return 'IND';
				}
				if (spouse && !domesticPartner && depCount < 1) {
					return 'ESP';
				}
				if (!spouse && !domesticPartner && depCount === 1) {
					return 'E1D';
				}
				if (!spouse && !domesticPartner && depCount > 1) {
					return 'ECH';
				}

				if ((spouse || domesticPartner) && depCount > 0) {
					return 'FAM';
				}
				if (!spouse && domesticPartner) {
					return 'TWO';
				}
			};

			this.getNewCategoryCodeMap = function() {
				return {
					subscriber: 0,
					spouse: 0,
					domesticPartner: 0,
					parasites: 0
				};
			};

			this.updateCategoryCodeMap = function(cccMap, relationshipCode) {
				switch (relationshipCode) {
					case '20': ++cccMap.subscriber;
						break;
					case '01': ++cccMap.spouse;
						break;
					case '29': ++cccMap.domesticPartner;
						break;
					default: ++cccMap.parasites;
				}
			};

			this.getCoverageCategoryCodeFromMap = function(cccMap) {
				if (!cccMap.subscriber) {
					return;
				}
				if (
					!cccMap.spouse &&
					!cccMap.domesticPartner &&
					cccMap.parasites < 1
				) {
					return 'IND';
				}
				if (
					cccMap.spouse &&
					!cccMap.domesticPartner &&
					cccMap.parasites < 1
				) {
					return 'ESP';
				}
				if (
					!cccMap.spouse &&
					!cccMap.domesticPartner &&
					cccMap.parasites === 1
				) {
					return 'E1D';
				}
				if (
					!cccMap.spouse &&
					!cccMap.domesticPartner &&
					cccMap.parasites > 1
				) {
					return 'ECH';
				}
				if (
					(cccMap.spouse || cccMap.domesticPartner) &&
					cccMap.parasites > 0
				) {
					return 'FAM';
				}
				if (
					!cccMap.spouse &&
					cccMap.domesticPartner
				) {
					return 'TWO';
				}
			};

			this.getAvailableProductsFor = function(c, employeeData) {
				var coveragesPayload = {
					version: 'v2',
					effectiveDate: c.effectiveDate || $filter('date')(employeeData.globalCoverageEffectiveDate, 'MM-dd-yyyy'),
					coverageType: c.coverageType,
					zipCode: c.zipCode || employeeData.subscriber.address.zipCode.base
				};
				return services.eprsvc.coverages(coveragesPayload).fetch().then(function(response) {
					if (
						response &&
						response.data &&
						Array.isArray(response.data.payload)
					){
						var group = response.data.payload.filter(
							function(g) { return g.groupNumber === c.groupNumber; }
						)[0];

						return group && group.products || [];
					}
				});
			};

			this.goThroughSubscriberLobsAndDo = function(employeeData, action) {
				if (employeeData.subscriber && Array.isArray(employeeData.subscriber.memberCoverages)) {
					employeeData.subscriber.memberCoverages.forEach(
						function(c) {
							c.memberLobs.forEach(
								function(lob) {
									action(lob, 0, c.groupNumber);
								}
							);
						}
					);
				}
			};

			this.goThroughDependentsLobsAndDo = function(employeeData, action) {
				for (var i = 0; i < employeeData.dependents.length; i++) {
					if (employeeData.dependents[i].memberCoverages) {
						for (var j = 0; j < employeeData.dependents[i].memberCoverages.length; j++) {
							for (var k = 0; k < employeeData.dependents[i].memberCoverages[j].memberLobs.length; k++) {
								action(employeeData.dependents[i].memberCoverages[j].memberLobs[k],
									i, //dependent index
									employeeData.dependents[i].memberCoverages[j].groupNumber
								);
							}
						}
					}
				}
			};

			this.pluck = function(arr, key, value) {
				for (var i = 0; i < arr.length; ++i) {
					if (arr[i][key] === value) {
						return arr[i];
					}
				}
			};

			this.relationshipMap = {
				'01': 'Spouse',
				'02': 'Son or Daughter',
				'03': 'Father or Mother',
				'04': 'Grandparent',
				'05': 'Grandchild',
				'06': 'Uncle or Aunt',
				'07': 'Nephew or Niece',
				'08': 'Cousin',
				'09': 'Adopted',
				'10': 'Foster Child',
				'11': 'In-Law (Son or Daughter)',
				'12': 'In-Law (Brother or Sister)',
				'13': 'In-Law (Mother or Father)',
				'14': 'Brother or Sister',
				'15': 'Ward (Under Care of Guardian)',
				'17': 'Stepson or Stepdaughter',
				'18': 'Self',
				'19': 'Child',
				'20': 'Employee',
				'21': 'Unknown',
				'23': 'Sponsored Dependent',
				'24': 'Dependent of a Minor Dependent',
				'25': 'Ex-Spouse Reserved Future Use',
				'26': 'Guardian',
				'28': 'Friend',
				'29': 'Domestic Partner',
				'30': 'Both Parents',
				'31': 'Court Appointed Guardian',
				'33': 'Father/Mother',
				'34': 'Other Adult',
				'36': 'Emancipated Minor',
				'45': 'Widow',
				'48': 'Stepfather or Stepmother',
				'50': 'Foster Parent'
			};

			this.typesOfCoverage = [
				'medical',
				'vision',
				'dental',
				'uccidental',
				'drug',
				'service'
			];

			this.prettyTypesOfCoverage = {
				medical: 'Medical',
				vision: 'Vision',
				dental: 'Dental',
				uccidental: 'UCCI Dental',
				drug: 'Drug',
				service: 'Service'
			};

			this.coverageTypeMap = {
				dental: [
					'DEN'
				],
				drug: [
					'PDG'
				],
				medical: [
					'CV',
					'FA',
					'GPO',
					'HMO',
					'MM',
					'POS',
					'PPO',
					'PR',
					'TDL',
					'WR'
				],
				service: [
					'AG',
					'ASC',
					'BO1',
					'BO2',
					'LR1',
					'MC1',
					'OS1',
					'WB2',
					'WB3',
					'WB4',
					'WC1',
					'WH1',
					'WR1'
				],
				vision: [
					'VIS'
				]
			};

			this.maybeGetModalType = function(additionalGroupInformation, product, currentDependent, subscriberGender) {
				product = product.toLowerCase();

				var dependentIsAdult = (function(adultAge) {
					var dependentAge = 100;
					if (currentDependent.birthDate && currentDependent.birthDate instanceof Date) {
						var ageDifMs = Date.now() - currentDependent.birthDate.getTime();
						var ageDate = new Date(ageDifMs);
						dependentAge = Math.abs(ageDate.getUTCFullYear() - 1970);
					}
					return Boolean(
						adultAge &&
						parseInt(adultAge) &&
						dependentAge >= parseInt(adultAge)
					);
				}(additionalGroupInformation.adultAge));

				if (
					product == 'dental' &&
					additionalGroupInformation.adultDentalAllowed &&
					!dependentIsAdult
				) {
					return 'adultDental';
				}
				if (
					product == 'vision' &&
					additionalGroupInformation.adultVisionAllowed &&
					!dependentIsAdult
				) {
					return 'adultVision';
				}
				if (
					additionalGroupInformation.domesticPartner == false &&
					currentDependent.relationshipCode == '29'
				) {
					return 'domesticPartner';
				}
				if (
					additionalGroupInformation.civilUnion == false &&
					currentDependent.relationshipCode == '01' &&
					currentDependent.gender == subscriberGender
				) {
					return 'civilUnion';
				}
				if (
					additionalGroupInformation.civilUnion == false &&
					currentDependent.relationshipCode == '29' &&
					currentDependent.gender == subscriberGender
				) {
					return 'civilUnionPart2';
				}
			}.bind(this);

			this.showCoverageModal = function(typeOfModal, scope, config) {
				switch (typeOfModal) {
					case 'adultDental':
						scope.modalContent = {
							header: 'Adult Dental',
							message: 'Members under 19 years old cannot be added to an Adult Dental plan.'
						};
						break;
					case 'adultVision':
						scope.modalContent = {
							header: 'Adult Vision',
							message: 'Members under 19 years old cannot be added to an Adult Vision plan.'
						};
						break;
					case 'domesticPartner':
						scope.modalContent = {
							header: 'Domestic Partner Benefits',
							message: 'The plan you have selected does not allow domestic partner benefits. Please contact Customer Service for assistance'
						};
						break;
					case 'civilUnion':
						scope.modalContent = {
							header: 'Civil Union Benefits',
							message: 'Spouse cannot have same gender as Subscriber'
						};
						break;
					case 'civilUnionPart2':
						scope.modalContent = {
							header: 'Civil Union Benefits',
							message: 'Domestic Partner cannot have same gender as Subscriber'
						};
						break;
					case 'cancelationNotice':
                        scope.modalContent = {
                            header: 'IMPORTANT',
                            message: 'Please be aware that this client has group policies that will end on:  <br>' +
                            '<ul><li>' +  config.cancelDate[0] + ' ' + '-' + ' ' + config.groupNumber[0] + '.</li>' +
                            '<li>' + ' ' + config.cancelDate[1] + ' ' + '-' + ' ' + config.groupNumber[1] + '.</li>' +
                            '<li>' + ' ' + config.cancelDate[2] + ' ' + '-' + ' ' + config.groupNumber[2] + '.</li></ul>' +

                            'This member has more than one policy year available for maintenance (add/cancel/modify) including:' + '<br>' +
                            '<span class="font-bold">1.	Current Group Policy Year Only</span> - ' +
                            'The member will be covered under the current group policy year until <br>' +
                            '<ul><li>' +  config.cancelDate[0] + ' ' + '-' + ' ' + config.groupNumber[0] + '.</li>' +
                            '<li>' + ' ' + config.cancelDate[1] + ' ' + '-' + ' ' + config.groupNumber[1] + '.</li>' +
                            '<li>' + ' ' + config.cancelDate[2] + ' ' + '-' + ' ' + config.groupNumber[2] + '.</li></ul>' +

                            '<span class="font-bold">2.	Upcoming Group Policy Year Only</span> - ' +
                            'The member will not have coverage until the upcoming group policy year begins.' + '<br>' +
                            '<span class="font-bold">3.	OR Both Group Policy Years</span> - ' +
                            'After the member is updated in one of the above, ' +
                            'go to the Edit Employee Record Page ' +
                            'to add/modify the member in each group for a different policy year.'
                        };
						break;
                    case 'cancelationNotice1':
                        scope.modalContent = {
                            header: 'IMPORTANT',
                            message: 'Please be aware that this client\'s current group policy year (' + config.groupNumber + ') will end on ' +
                            config.cancelDate +
                            '. This member has more than one policy year available for maintenance (add/cancel/modify) including:' + '<br>' +
                            '<span class="font-bold">1.	Current Group Policy Year Only</span> - ' +
                            'The member will be covered under the current group policy year until ' +
                            config.cancelDate + '.<br>' +
                            '<span class="font-bold">2.	Upcoming Group Policy Year Only</span> - ' +
                            'The member will not have coverage until the upcoming group policy year begins.' + '<br>' +
                            '<span class="font-bold">3.	OR Both Group Policy Years</span> - ' +
                            'After the member is updated in one of the above, ' +
                            'go to the Edit Employee Record Page ' +
                            'to add/modify the member in each group for a different policy year.'
                        };
                        break;
                    case 'cancelationNotice2':
                        scope.modalContent = {
                            header: 'IMPORTANT',
                            message: 'Please be aware that this client has group policies that will end on:  <br>' +
                            '<ul><li>' +  config.cancelDate[0] + ' ' + '-' + ' ' + config.groupNumber[0] + '.</li>' +
                            '<li>' + ' ' + config.cancelDate[1] + ' ' + '-' + ' ' + config.groupNumber[1] + '.</li></ul>' +
							'This member has more than one policy year available for maintenance (add/cancel/modify) including:' + '<br>' +
                            '<span class="font-bold">1.	Current Group Policy Year Only</span> - ' +
                            'The member will be covered under the current group policy year until <br>' +
                            '<ul><li>' +  config.cancelDate[0] + ' ' + '-' + ' ' + config.groupNumber[0] + '.</li>' +
                            '<li>' + ' ' + config.cancelDate[1] + ' ' + '-' + ' ' + config.groupNumber[1] + '.</li></ul>' +

                            '<span class="font-bold">2.	Upcoming Group Policy Year Only</span> - ' +
                            'The member will not have coverage until the upcoming group policy year begins.' + '<br>' +
                            '<span class="font-bold">3.	OR Both Group Policy Years</span> - ' +
                            'After the member is updated in one of the above, ' +
                            'go to the Edit Employee Record Page ' +
                            'to add/modify the member in each group for a different policy year.'
                        };
                        break;
                    case 'cancelCoverageNotice':
                        scope.modalContent = {
                            header: 'IMPORTANT',
                            message: 'Please be aware that this client\'s group policy (' + config.groupNumber + ') year will end on (' +
                            config.cancelDate + ').' + '<br>' +
                            'The member can be cancelled from the current group policy (' + config.cancelDate +
							') year on or prior to the group cancellation date.'
                        };
                        break;
                    case 'cancelCoverageUpcomingNotice':
                        scope.modalContent = {
                            header: 'IMPORTANT',
                            message: 'Please be aware that this client has group policies that will end on: ' + ' ' + config.cancelDate + ' ' + '-' + ' ' + config.groupNumber+ '.<br>' +
                            '<span class="font-bold">1.	Current Group Policy Year Only</span> - ' +
                            'The member can be cancelled from the current group policy  ' +
                            'year on or prior to the group cancellation date.<br>' +
                            '<span class="font-bold">2.	Upcoming Group Policy Year Only</span> - ' +
                            'The member can be cancelled from the upcoming group policy year beginning ' +
                            'on the selected effective date of cancellation.'
                        };
                        break;
                    case 'cancelCoverageMulti':
                        scope.modalContent = {
                            header: 'IMPORTANT',
                            message: 'Please be aware that this client has group policies that will end on:  <br>' +
                            '<ul><li>' +  config.cancelDate[0] + ' ' + '-' + ' ' + config.groupNumber[0] + '.</li>' +
                            '<li>' + ' ' + config.cancelDate[1] + ' ' + '-' + ' ' + config.groupNumber[1] + '.</li></ul>' +
                            '<span class="font-bold">1.	Current Group Policy Year Only</span> - ' +
                            'The member can be cancelled from the current group policy  ' +
							'year on or prior to the group cancellation date.<br>' +
                            '<span class="font-bold">2.	Upcoming Group Policy Year Only</span> - ' +
                            'The member can be cancelled from the upcoming group policy year beginning ' +
                            'on the selected effective date of cancellation.'
                        };
                        break;
                    case 'cancelCoverageMultiMess':
                        scope.modalContent = {
                            header: 'IMPORTANT',
                            message: 'Please be aware that this client has group policies that will end on:  <br>' +
                            '<ul><li>' +  config.cancelDate[0] + ' ' + '-' + ' ' + config.groupNumber[0] + '.</li>' +
                            '<li>' + ' ' + config.cancelDate[1] + ' ' + '-' + ' ' + config.groupNumber[1] + '.</li>' +
                            '<li>' + ' ' + config.cancelDate[2] + ' ' + '-' + ' ' + config.groupNumber[2] + '.</li></ul>' +
                            '<span class="font-bold">1.	Current Group Policy Year Only</span> - ' +
                            'The member can be cancelled from the current group policy  ' +
                            'year on or prior to the group cancellation date.<br>' +
                            '<span class="font-bold">2.	Upcoming Group Policy Year Only</span> - ' +
                            'The member can be cancelled from the upcoming group policy year beginning ' +
                            'on the selected effective date of cancellation.'
                        };
                        break;
					case 'noProductSelected':
						var ubk = sessionData.employerInfo.brandName;
						if(ubk == '6012'){
							scope.modalContent = {
								header: 'No Products Selected',
								message: 'Please select at least one product to enroll, or return to the subscriber page to waive coverage.'
							};
						}
						else{
							scope.modalContent = {
								header: 'No Products Selected',
								message: 'You must enroll in at least one product, or return to the Subscriber page to waive coverage.'
							};
						}
						break;
					case 'productWithNoMembers':
						scope.modalContent = {
							header: 'Product Selected with no Members',
							message: 'In order to enroll in ' + config.erroringProduct + ' coverage, at least one participant must be selected.'
						};
						break;
					case 'genericError':
						return modal.open({
							template: '<article class="medicare-history-modal">'+
							'<section class="modal-header">'+
							'<h4 class="modal-title">An Error Occured</h4>'+
							'<hr>'+
							'</section>'+
							'<section>'+
							'<br>'+
							'<p>We apologize, but there seems to be an error with this page.  Please try again later.</p>'+
							'<button class="secondary-button-1" data-ng-click="closeModal()">Return Home</button>'+
							'</section>'+
							'</article>',
							scope: scope,
							onClose: function() { $state.go('home'); }
						});
				}
				modal.open({
					template: require('pages/employee/modals/genericInfoModal.html'),
					scope: scope
				});
			};
		}
	]);
};
